<template>
  <li :class="{ 'treeview': isMulti }">
    <!-- Menu Item Link -->
    <a :href="itemHref">
      <!-- Icon -->
      <i :class="item.menu_item_icone"></i>
      <span>{{ item.menu_item_titulo }}</span>

      <!-- Arrow for multi items -->
      <span v-if="isMulti" class="pull-right-container">
        <i class="pi pi-angle-left pull-right"></i>
      </span>
    </a>

    <!-- Submenu for multi items -->
    <ul v-if="isMulti && hasChildren" class="treeview-menu">
      <MenuItem
        v-for="child in children"
        :key="child.menu_item_id"
        :item="child"
        :allItems="allItems"
      />
    </ul>
  </li>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { log } from '../utils/DebugLogger';

interface MenuItem {
  menu_item_id: number | string;
  menu_item_pai_id?: number | string | null;
  menu_item_tipo: string;
  menu_item_icone?: string;
  menu_item_titulo: string;
  menu_item_controller?: string;
}

// Props
const props = defineProps<{
  item: MenuItem;
  allItems: MenuItem[];
}>();

// Computed
const isMulti = computed(() => {
  return props.item.menu_item_tipo === 'multi';
});

const isSingle = computed(() => {
  return props.item.menu_item_tipo === 'single';
});

const itemHref = computed(() => {
  if (isMulti.value) {
    return '#';
  }
  if (isSingle.value && props.item.menu_item_controller) {
    // Get base URL from window or construct it
    const baseUrl = window.location.origin + window.location.pathname.split('/index.php')[0];
    return `${baseUrl}/index.php/${props.item.menu_item_controller}`;
  }
  return '#';
});

const children = computed(() => {
  return props.allItems.filter(childItem =>
    childItem.menu_item_pai_id == props.item.menu_item_id
  );
});

const hasChildren = computed(() => {
  return children.value.length > 0;
});
</script>

<style scoped>
/* AdminLTE menu item styles are already defined globally */
/* This component uses existing AdminLTE classes */
</style>
